// "energy.<key>" 로 부르는 문구. 값에 {name} 을 두면 t(key, { name }) 로 채운다.
// 에너지 탭(Energy.jsx)과 그 아래 EnergyInsight/*, 데모 에너지 패널이 쓴다.
const energy = {
  ko: {
    "forecast.reference": "예보 기준",
    "tab.title": "에너지",
    "fetch.failed": "에너지 데이터를 불러오지 못했습니다.",

    // 장비 칩. 스마트폴 / 스마트큐브는 같은 API 지만 사용자에게는 다른 장비다.
    "device.POLE": "스마트폴",
    "device.CUBE": "스마트큐브",
    "device.unregistered": "미등록",
    // 큐브 여러 대: "스마트큐브 3대". 구성 칩은 fog 공유 / 개별 운영 / 장치 없음.
    "device.count": "{device} {n}대",
    "device.disconnected": "데이터 수신 끊김",
    "device.lastSeen": "마지막 수신 {ago}",
    "mode.POLE": "단독",
    "mode.EDGE_ONLY": "개별 운영 · 전력 공유 없음",
    "mode.FOG": "fog 공유 모드",
    "mode.NONE": "연결된 장치 없음",
    "role.FOG": "FOG",
    "role.EDGE": "EDGE",
    "edgeOnly.note": "fog가 없어 큐브끼리 전력을 공유하지 않습니다. 큐브마다 따로 보여줍니다.",
    // 제목 옆 "?" 도움말. fog 구성에서만 보인다 — 그룹 합계 · fog 카드 · edge 카드가 뭐가 다른지.
    "help.label": "도움말",
    "help.fogGroup": "큐브 전체 합계는 이 농장의 큐브 전부를 더한 값입니다. fog는 그중 전력 공유를 맡는 큐브 1대이고, fog 카드는 그 큐브 1대의 값만 보여줍니다. 나머지 큐브가 edge입니다.",
    "help.surplus": "남는 전력 = 전체 발전 − 전체 소비. 남으면 발전이 소비보다 많아 배터리를 채우는 중이고, 모자라면 소비가 발전보다 많아 배터리에서 꺼내 쓰는 중입니다.",

    // 수신 경과("2분 전")
    "ago.justNow": "방금 전",
    "ago.minutes": "{n}분 전",
    "ago.hours": "{n}시간 전",
    "ago.days": "{n}일 전",

    // 장비 미등록 / 데이터 미수신 안내
    "state.missingIdentifier": "{device} 장비가 이 농장에 등록·연결되어 있는지 확인해 주세요.",
    "state.noIncomingData": "{device} 장비는 등록되어 있지만 현재 에너지 데이터를 수신하지 못하고 있습니다.",
    "state.noDevice": "이 농장에 연결된 에너지 장치가 없습니다. 관리자에게 장비 연결을 요청해 주세요.",

    // 현재 발전 패널(폴). 합계 큰 숫자 + 태양광 · 풍력 · 소비 · 배터리 타일
    "generation.title": "현재 발전",
    "generation.solar": "태양광",
    "generation.wind": "풍력",
    "generation.total": "합계",
    "generation.cons": "소비",
    "generation.battery": "배터리",

    // 큐브 카드(장치 1대) 숫자 타일
    "kpi.gen": "실시간 발전",
    "kpi.cons": "실시간 소비",
    "kpi.battery": "배터리",

    // fog 구성에서 큐브가 주고받는 전력 한 줄 (하드웨어 값이 오면 보인다)
    "shared.in": "받음",
    "shared.out": "보냄",
    "shared.hint.receiving": "다른 큐브에서 전력을 받는 중",
    "shared.hint.giving": "남는 전력을 나눠주는 중",
    "shared.hint.none": "주고받는 전력 없음",

    // 실측 6시간 + 예측 6시간 차트 (1시간 점, 2시간 눈금). 예측은 AI 값이 오면 점선이 채워진다.
    "timeline.hourTick": "{h}시",
    "timeline.now": "지금",
    // 큐브는 발전 + 소비, 폴은 태양광 · 풍력 · 소비. 소비는 배터리 하나로 모여 한 값이다.
    "timeline.next": "+1h 예측 발전 {gen} W · 소비 {cons} W",
    "timeline.nextPole": "+1h 예측 태양광 {solar} W · 풍력 {wind} W · 소비 {cons} W",
    "timeline.forecastPending": "예측은 AI 연동 후 표시",
    "timeline.gen": "발전",
    "timeline.cons": "소비",
    "timeline.forecast": "예측",
    "timeline.pastForecast": "당시 {name}",
    "timeline.genMeasured": "실측 발전",
    "timeline.consMeasured": "실측 소비",
    "timeline.genForecast": "예측 발전",
    "timeline.consForecast": "예측 소비",
    // 스마트폴: 발전을 태양광 · 풍력으로 나눠 그린다
    "timeline.solar": "태양광",
    "timeline.wind": "풍력",
    "timeline.solarMeasured": "실측 태양광",
    "timeline.windMeasured": "실측 풍력",
    "timeline.solarForecast": "예측 태양광",
    "timeline.windForecast": "예측 풍력",
    // 차트 오른쪽 위 + 버튼 → 크게 보기 모달
    "timeline.expand": "크게 보기",
    "timeline.modal.title": "실측 · 예측 상세",
    "timeline.modal.basis": "{date} {h}시 기준",
    "timeline.modal.close": "닫기",
    "timeline.modal.next": "+1h 예측",
    "timeline.modal.error": "완료 시간대 오차",
    "timeline.modal.currentHourAverage": "현재 시간대 평균",
    "timeline.modal.compare": "실측·예측 비교",
    "timeline.modal.measured": "실측",
    "timeline.modal.forecast": "예측",
    "timeline.modal.zone": "예측 구간",
    "timeline.modal.zoneLabel": "AI 예측",

    // 큐브 카드 접기/펼치기
    "device.summary": "발전 {gen} W · 소비 {cons} W · 배터리 {soc}%",
    "device.expand": "펼치기",
    "device.collapse": "접기",

    // 큐브 전체 합계 카드. "fog 그룹 합계"라고 하면 fog 큐브 1대 값과 헷갈려 "큐브 전체 합계"로(10-20)
    "group.title": "큐브 전체 합계",
    // 남는 전력 라벨은 부호를 말로 한다. 값이 +면 surplus, −면 deficit(크기만 적고 빨강). 배터리 뜻은 help.surplus(? 도움말)에.
    "group.surplus": "지금 남는 전력",
    "group.deficit": "지금 모자라는 전력",
    "group.totalGen": "총 실시간 발전",
    "group.totalCons": "총 실시간 소비",
    "group.basis": "{total}대 중 {reporting}대 데이터 기준",
    "group.fogDown": "fog({name})의 데이터 수신이 끊겼습니다. 전력 공유가 멈췄을 수 있고, 합계는 데이터가 오는 {reporting}대 기준입니다.",

    // 에너지 추이 패널
    "monitoring.title": "에너지 추이",
    "monitoring.loading": "에너지 데이터를 불러오는 중입니다.",
    "monitoring.empty": "선택한 기간에 표시할 에너지 데이터가 없습니다.",
    "monitoring.tab.generation": "발전",
    "monitoring.tab.consumption": "소비",
    "monitoring.series.measured": "{label} 실측",
    "monitoring.cumulative": "누적",
    // 큐브가 여러 대면 추이 차트 위에 장치 선택 줄이 붙는다. fog 구성은 그룹 합계가 맨 앞.
    "monitoring.series.group": "큐브 전체",

    // 데모 시나리오 전용
    "demo.generation.title": "실시간 발전량",
    "demo.trend.title": "주간 에너지 추이",
    "demo.tooltip.value": "데모 값",
    "demo.legend": "데모 스마트폴 측정값",
  },
  en: {
    "forecast.reference": "Forecast origin",
    "tab.title": "Energy",
    "fetch.failed": "Failed to load energy data.",

    "device.POLE": "SmartPole",
    "device.CUBE": "SolarCube",
    "device.unregistered": "Not registered",
    "device.count": (p) => `${p.n} ${p.device}${p.n === 1 ? "" : "s"}`,
    "device.disconnected": "No incoming data",
    "device.lastSeen": "last seen {ago}",
    "mode.POLE": "Standalone",
    "mode.EDGE_ONLY": "Standalone · no power sharing",
    "mode.FOG": "fog sharing",
    "mode.NONE": "No device connected",
    "role.FOG": "FOG",
    "role.EDGE": "EDGE",
    "edgeOnly.note": "There is no fog, so the cubes do not share power. Each cube is shown on its own.",
    "help.label": "Help",
    "help.fogGroup": "All cubes total adds up every cube on this farm (fog + edges). The fog is the single cube in charge of power sharing, and its card shows that one cube only. The other cubes are edges.",
    "help.surplus": "Surplus = total generation − total consumption. A surplus means the batteries are charging; a shortfall means the cubes are drawing from the batteries.",

    "ago.justNow": "just now",
    "ago.minutes": (p) => `${p.n} minute${p.n === 1 ? "" : "s"} ago`,
    "ago.hours": (p) => `${p.n} hour${p.n === 1 ? "" : "s"} ago`,
    "ago.days": (p) => `${p.n} day${p.n === 1 ? "" : "s"} ago`,

    "state.missingIdentifier": "Please check whether {device} is registered and connected to this farm.",
    "state.noIncomingData": "{device} is registered, but no energy data is currently being received.",
    "state.noDevice": "No energy device is connected to this farm. Ask an administrator to connect one.",

    "generation.title": "Current Generation",
    "generation.solar": "Solar",
    "generation.wind": "Wind",
    "generation.total": "Total",
    "generation.cons": "Consumption",
    "generation.battery": "Battery",

    "kpi.gen": "Generation now",
    "kpi.cons": "Consumption now",
    "kpi.battery": "Battery",

    "shared.in": "Received",
    "shared.out": "Sent",
    "shared.hint.receiving": "Receiving power from other cubes",
    "shared.hint.giving": "Sharing surplus power",
    "shared.hint.none": "No power exchanged",

    "timeline.hourTick": "{h}:00",
    "timeline.now": "now",
    "timeline.next": "+1h forecast: generation {gen} W · consumption {cons} W",
    "timeline.nextPole": "+1h forecast: solar {solar} W · wind {wind} W · consumption {cons} W",
    "timeline.forecastPending": "Forecast appears once the AI feed is connected",
    "timeline.gen": "Generation",
    "timeline.cons": "Consumption",
    "timeline.forecast": "Forecast (dashed)",
    "timeline.pastForecast": "Issued {name}",
    "timeline.genMeasured": "Measured generation",
    "timeline.consMeasured": "Measured consumption",
    "timeline.genForecast": "Forecast generation",
    "timeline.consForecast": "Forecast consumption",
    "timeline.solar": "Solar",
    "timeline.wind": "Wind",
    "timeline.solarMeasured": "Measured solar",
    "timeline.windMeasured": "Measured wind",
    "timeline.solarForecast": "Forecast solar",
    "timeline.windForecast": "Forecast wind",
    "timeline.expand": "Enlarge",
    "timeline.modal.title": "Measured vs forecast",
    "timeline.modal.basis": "As of {date} {h}:00",
    "timeline.modal.close": "Close",
    "timeline.modal.next": "+1h forecast",
    "timeline.modal.error": "Completed-hour error",
    "timeline.modal.currentHourAverage": "Current hour average",
    "timeline.modal.compare": "Compare with measured",
    "timeline.modal.measured": "Measured",
    "timeline.modal.forecast": "Forecast",
    "timeline.modal.zone": "Forecast window",
    "timeline.modal.zoneLabel": "AI forecast",

    "device.summary": "Gen {gen} W · Cons {cons} W · Battery {soc}%",
    "device.expand": "expand",
    "device.collapse": "collapse",

    "group.title": "All cubes total",
    "group.surplus": "Surplus now",
    "group.deficit": "Shortfall now",
    "group.totalGen": "Total generation now",
    "group.totalCons": "Total consumption now",
    "group.basis": "Based on {reporting} of {total} devices reporting",
    "group.fogDown": "No data is coming from fog ({name}). Power sharing may have stopped; totals cover the {reporting} devices still reporting.",

    "monitoring.title": "Energy Trend",
    "monitoring.loading": "Loading energy data...",
    "monitoring.empty": "No energy data to display for the selected period.",
    "monitoring.tab.generation": "Generation",
    "monitoring.tab.consumption": "Consumption",
    "monitoring.series.measured": "{label} measured",
    "monitoring.cumulative": "Total",
    "monitoring.series.group": "All cubes",

    "demo.generation.title": "Live Generation",
    "demo.trend.title": "Weekly Energy Trend",
    "demo.tooltip.value": "Demo value",
    "demo.legend": "Demo SmartPole readings",
  },
};

export default energy;
